// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact__2t1EV","title":"contact_title__wWt0b","btn":"contact_btn__18ZeQ","message":"contact_message__27ly4"};